import { MENU_IMPORT_MAX_ITEMS, menuImportKey, validateReviewedMenuImport } from '../supabase/edge-functions/_shared/menuImport';

export function readMenuImportDraft(key) {
  try {
    const draft = JSON.parse(localStorage.getItem(key) || 'null');
    if (![1, 2].includes(draft?.version) || !Number.isFinite(draft.savedAt) ||
      draft.savedAt > Date.now() || Date.now() - draft.savedAt >= 7 * 86400000 ||
      !Array.isArray(draft.warnings) || !draft.warnings.every((warning) => typeof warning === 'string') ||
      !Array.isArray(draft.rows) || !draft.rows.length || draft.rows.length > MENU_IMPORT_MAX_ITEMS ||
      !draft.rows.every((row) => typeof row?.rowId === 'string' &&
        ['name', 'category', 'subcategory', 'description'].every((field) => typeof row[field] === 'string') &&
        ['number', 'string'].includes(typeof row.price) && typeof row.selected === 'boolean' &&
        ['note', 'priceText'].every((field) => row[field] == null || typeof row[field] === 'string'))) return null;
    const ids = new Set(draft.rows.map((row) => row.rowId));
    if (ids.size !== draft.rows.length) return null;
    return { ...draft,
      reviewIndex: Number.isInteger(draft.reviewIndex) ? Math.max(0, Math.min(draft.rows.length, draft.reviewIndex)) : 0,
      reviewedIds: Array.isArray(draft.reviewedIds) ? [...new Set(draft.reviewedIds.filter((id) => ids.has(id)))] : [],
    };
  } catch { return null; }
}

export function menuImportReviewIssues(rows) {
  const seen = new Set();
  const issues = [];
  rows.forEach((row, index) => {
    if (!row.selected) return;
    try {
      validateReviewedMenuImport([row]);
      const key = [row.category, row.subcategory, row.name].map(menuImportKey).join('|');
      if (seen.has(key)) throw new Error('Esta repetido en la misma categoria. Desmarca una de las filas.');
      seen.add(key);
    } catch (error) {
      issues.push({ rowId: row.rowId, index, message: error.message.replace('del plato 1.', 'de este plato.') });
    }
  });
  return issues;
}
